// extracted by css-extract-rspack-plugin
export default {"ipsThumbnail":"Mct5VLHBEu0cFNWJ"};